import { css } from "styled-components";

export const strongButtonStyles = (
  $type: "solid" | "outline" | "text",
  $dark?: boolean
) => {
  if ($type === "solid") {
    return css`
      background: var(--strong);
      border: 0.1rem solid transparent;
      & > p {
        color: var(--normal);
      }
      & > svg path {
        stroke: var(--normal);
      }
      &:hover {
        background: ${$dark
          ? "rgba(203, 203, 207, 0.24)"
          : "rgba(7, 7, 7, 0.56)"};
      }
      &:active {
        background: ${$dark
          ? `linear-gradient(
          0deg, 
          rgba(7, 7, 7, 0.48) 0%
          , rgba(7, 7, 7, 0.48) 100%
          ), 
          var(--strong, #FEFEFE)`
          : `linear-gradient(
          0deg,
          rgba(254, 254, 254, 0.48) 0%,
          rgba(254, 254, 254, 0.48) 100%
          ),
          var(--strong, #070707)`};
      }
      &.selected {
        background: var(--pri-blue-1);
      }
      &:disabled {
        background: var(--bg-gray-2);
        & > p {
          color: var(--text-gray-0);
        }
        & > svg path {
          stroke: var(--text-gray-0);
        }
      }
    `;
  }

  if ($type === "outline") {
    return css`
      background: transparent;
      border: 1px solid var(--strong);
      & > p {
        color: var(--strong);
      }
      & > svg path {
        stroke: var(--strong);
      }
      &:hover {
        background: ${$dark
          ? "rgba(203, 203, 207, 0.24)"
          : "rgba(139, 139, 147, 0.24)"};
      }
      &:active {
        background: ${$dark
          ? "rgba(7, 7, 7, 0.32)"
          : "rgba(254, 254, 254, 0.32)"};
      }
      &.selected {
        background: var(--pri-blue-1);
        border: 0.1rem solid var(--strong);
      }
      &:disabled {
        background: transparent;
        border: 0.1rem solid var(--bg-gray-2);
        & > p {
          color: var(--bg-gray-2);
        }
        & > svg path {
          stroke: var(--bg-gray-2);
        }
      }
    `;
  }

  if ($type === "text") {
    return css`
      background: transparent;
      border: 0.1rem solid transparent;
      & > p {
        color: var(--strong);
      }
      & > svg path {
        stroke: var(--strong);
      }
      &:hover {
        background: ${$dark
          ? "rgba(203, 203, 207, 0.24)"
          : "rgba(139, 139, 147, 0.24)"};
      }
      &:active {
        background: ${$dark
          ? "rgba(7, 7, 7, 0.32)"
          : "rgba(254, 254, 254, 0.32)"};
      }
      &.selected {
        background: var(--pri-blue-1);
        /* border: 0.1rem solid var(--strong); */
      }
      &:disabled {
        background: transparent;
        & > p {
          color: var(--bg-gray-2);
        }
        & > svg path {
          stroke: var(--bg-gray-2);
        }
      }
    `;
  }
};
